import React from 'react'
import { Box, ButtonGroup, CircularProgress, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Paper } from '@mui/material'
import { Button } from '../../controls';
import { DeleteTwoTone } from '@mui/icons-material';
import { useQuery } from 'react-query';
import { httpClient } from '../../utils';
import { Spinner } from '../../layouts';

async function fetchMeal(id) {
    try {
        const {data} = await httpClient.get(`meals/${id}`)
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

const OrderItem = (props) => {
    const {item, deleteMeal, updateQuantity} = props;

    const {data, status} = useQuery(`meal${item.mealId}`, () => fetchMeal(item.mealId));

    if (status === 'idle' || status === 'loading') return (
      <Spinner />
    )

    if (status === 'success') return (
        <Paper >
            <ListItem >
              <ListItemText 
                primary={data.mealName}
                primaryTypographyProps={{
                  component:'h1',
                  style: {
                    fontWeight:'500',
                    fontSize: '1.2em'
                  }
                }}
                secondary={
                    <>
                        <ButtonGroup>
                            <Button sx={{ color:'#000' }} size={'small'} onClick={() => updateQuantity(data.mealId, item.quantity - 1)} >-</Button>
                            <Button sx={{ color:'#000', backgroundColor:'#fff' }} size={'small'} >{item.quantity}</Button>
                            <Button sx={{ color:'#000' }} size={'small'} onClick={() => updateQuantity(data.mealId, item.quantity + 1)} >+</Button>
                        </ButtonGroup>
                        <Box component={'span'} >{parseFloat(data.mealPrice * item.quantity).toFixed(2)} DH</Box>
                    </>
                }
                secondaryTypographyProps={{
                    component: 'div',
                }}
              />
              <ListItemSecondaryAction >
                <IconButton onClick={() => deleteMeal(data.mealId)} disableRipple >
                  <DeleteTwoTone />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
        </Paper>    
    )
}

export default OrderItem